import jwt_decode from 'jwt-decode'
import axios from 'axios'
import {
  getToken,
  setRefreshToken,
  setToken,
  getRefreshToken,
  getMobileToken,
  getLoginType,
  hasAccess
} from './tokenCheck'
import store from '../store'
const qs = require('qs')

const trainingServe = axios.create({
  baseURL:
    // "https://training-api.simplifycv.com/", // development
    // "https://training-api.simplifymycareer.com/", // staging
    "https://gateway.hire3x.com/training/", // production
});

const serviceRequest = axios.create({
  // baseURL: "https://admin-api.simplifycv.com/",
  baseURL: "https://admin-api.hire3x.com/",
});

serviceRequest.interceptors.request.use(
  (body) => {
    // body.headers["Authorization"] = "Bearer " + getToken();
    body.headers["userID"] = getProcessedToken();
    return body;
  },
  (error) => {
    console.error(error);
    Promise.reject(error);
  },
);

serviceRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return error.response;
  },
);

trainingServe.interceptors.request.use(
  (config) => {
     config.baseURL = hasAccess()
      ? "https://gateway.hire3x.com/training"
      : "https://training-api.hire3x.com/";
    // config.headers["userID"] = "ed9c7555-5681-44b1-9cf0-e5094bada550";
    // config.headers["userID"] = getProcessedToken();
    // const vueToken = localStorage.getItem("vue_token");
    if(getToken()){
      config.headers["Authorization"] = "Bearer " + getToken();
    }

    // if (vueToken) {
    //   config.headers["userID"] = getProcessedToken();
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

trainingServe.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle response error
    if (
      hasAccess() &&
      (error.response == undefined ||
      error.response.status == 403)
    ) {
      await refreshAccessToken()
      error.config.headers['Authorization'] = 'bearer ' + getToken()
      return axios(error.config)
    } else {
      return error.response
    }
  },
);

// Base URL for Token API
const serviceSSO = axios.create({
  baseURL:
    //  "https://auth.simplifymycareer.com/", // development and staging
    "https://auth.hire3x.com/", // production
});

const prefRequest = axios.create({
  baseURL: "https://api-website.hire3x.com/",
  // baseURL: "https://api-website.hire3x.com/",
});

// Base URL for Forgot Password API
const SysToken = axios.create({
  baseURL: "https://keynode.hire3x.com/",
});

const ServiceCandidate = axios.create()
const serviceRecruitment = axios.create();

serviceRecruitment.interceptors.request.use((config) => {
	config.baseURL = hasAccess()
		? "https://gateway.hire3x.com/recruitment/"
		: "https://recruitment-api.hire3x.com/";

	// Uncomment the line below for local backend testing
	// config.baseURL = "http://127.0.0.1:8000/";

	return config;
});

// serviceRecruitment - Authorization only
serviceRecruitment.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
const notificationAuth = axios.create({
  // baseURL: "https://notification.simplifycv.com/", // Dev Gateway
  baseURL: 'https://notification.hire3x.com/', // Staging Gateway
})

const paymentService = axios.create({
  baseURL: 'https://payment.hire3x.com/',
})

const ServiceCandidateParser = axios.create({
  baseURL: "https://resumeparser.hire3x.com",
});

const KeynodeService = axios.create({
  baseURL: "https://keynode.hire3x.com/",
});

ServiceCandidateParser.interceptors.request.use(
  (config) => {
    const token = getToken();
    const userID = getProcessedToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    if (userID) {
      config.headers["userID"] = userID;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

prefRequest.interceptors.request.use(
  (config) => {
    // config.headers["Authorization"] = "Bearer " + getToken();
    config.headers["userID"] = getProcessedToken();
    // config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
    // config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";

    return config;
  },
  (error) => {
    // Do something with request error
    return error;
 }
);

SysToken.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

ServiceCandidate.interceptors.request.use(
  (config) => {
    (config.baseURL = hasAccess()
      ? "https://gateway.hire3x.com/candidate"
      : "https://candidate-api.hire3x.com/"),
      (config.headers["Authorization"] = "Bearer " + getToken());
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

ServiceCandidate.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    // Handle response error
    if (
      hasAccess() &&
      (error.response == undefined ||
      error.response.status == 403)
    ) {
      await refreshAccessToken()
      error.config.headers['Authorization'] = 'bearer ' + getToken()
      return axios(error.config)
    } else {
      return error.response
    }
  },
);

paymentService.interceptors.request.use(
  (config) => {
    config.headers["userID"] = getProcessedToken();
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

paymentService.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle response error
    if (
      hasAccess() &&
      (error.response == undefined ||
      error.response.status == 403 ||
      error.response.status == 401)
    ) {
      await refreshAccessToken()
      error.config.headers['Authorization'] = 'bearer ' + getToken()
      return axios(error.config)
    } else {
      return error.response
    }
  },
);
function getProcessedToken() {
  try {
    const token = getToken();
    if (!token) return null;
    const decoded = jwt_decode(token);
    return decoded.sub;
  } catch (error) {
    return null;
  }
}
const publicService = axios.create({
  baseURL: "https://training-api.hire3x.com/candidate/",
});

const assessmentUrl = axios.create({
  baseURL: "https://gateway.hire3x.com/assessment/",
});

assessmentUrl.interceptors.request.use(
  (config) => {
    // config.headers["u"] = getUserID();
    config.headers["Authorization"] = "Bearer " + getToken();

    return config;
  },
  (error) => {
    return error;
  },
);

assessmentUrl.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return error.response;
  },
);

const requestSuggestion = axios.create({
  // baseURL: "https://suggestions.simplifycv.com/",
  baseURL: "https://suggestions.hire3x.com/"
});

requestSuggestion.interceptors.request.use(
  (config) => {
    const userID = getProcessedToken();
    if (userID) {
      config.headers["userID"] = userID;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Getting new Access token using Refresh token (Keycloak)
const getNewAccessToken = async () => {
  let payload = qs.stringify({
    grant_type: 'refresh_token',
    client_id: getMobileToken() ? 'hire3x-app' : 'vue-test-app',
    refresh_token: getRefreshToken(),
  })

  try {
    const response = await axios({
      method: 'post',
      url:
        // "https://auth.simplifymycareer.com/auth/realms/hire3x-dev/protocol/openid-connect/token", // Dev
        // "https://auth.simplifymycareer.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Staging
        "https://auth.hire3x.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Prod
      data: payload,
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    })

    setToken(response.data.access_token)
    setRefreshToken(response.data.refresh_token)
    store.commit('userVUEX/SET_TOKEN', response.data.access_token)
    store.commit('userVUEX/SET_REFRESH_TOKEN', response.data.refresh_token)
    if (response.status == 400) {
      store.dispatch('userVUEX/LogOut')
    }
  } catch (error) {
    store.dispatch('userVUEX/LogOut')
  }
}

// Refresh Google access token using the backend endpoint
const refreshGoogleToken = async () => {
  const refreshToken = getRefreshToken()

  try {
    const response = await ServiceCandidate.post('/can/auth/google-refresh/', {
      refresh_token: refreshToken,
    })

    if (response.data.type === 'Success') {
      const tokens = response.data.data
      setToken(tokens.id_token)
      store.commit('userVUEX/SET_TOKEN', tokens.id_token)
      // Note: Google doesn't return a new refresh_token on refresh, so we keep the existing one
    } else {
      console.error('Google token refresh failed:', response.data)
      store.dispatch('userVUEX/LogOut')
    }
  } catch (error) {
    if (
      axios.isCancel(error) ||
      ['ECONNABORTED', 'ERR_CANCELED'].includes(error.code)
    ) {
      console.warn('Google token refresh request cancelled')
      return
    }
    console.error('Google token refresh error:', error)
    store.dispatch('userVUEX/LogOut')
  }
}

// Unified function to refresh access token based on login type
const refreshAccessToken = async () => {
  const loginData = getLoginType()
  if (loginData && loginData.logged_in === 'google') {
    // User logged in via Google - use Google refresh endpoint
    await refreshGoogleToken()
  } else {
    // User logged in via Keycloak - use existing refresh flow
    await getNewAccessToken()
  }
}

export {
  serviceRecruitment,
  prefRequest,
  trainingServe,
  serviceSSO,
  SysToken,
  getProcessedToken,
  ServiceCandidate,
  paymentService,
  getNewAccessToken,
  refreshGoogleToken,
  refreshAccessToken,
  notificationAuth,
  serviceRequest,
  publicService,
  assessmentUrl,
  ServiceCandidateParser,
  KeynodeService,
  requestSuggestion,
};
